import { BackendAdapterCube, ICubeResponse } from "@spawn/backend-adapter-cube";
import { consumer, inject } from "@spawn/core";
import { NudgeUpService } from "../../services/nudgeUpService";
import { BaseSymbolTypes } from "../../services/symbolService";
import { CacheKeys, CacheStorage } from "../../utils/cacheStorage";
import { IGameNetworkState } from "../networkState";
import { INrgCubeGameResult } from "../types/cube";
import { ExtendedSpinActionCube } from "./extendedSpinActionCube";

/**
 * Specs say Free games should start with a new reelset that includes mystery symbols on reels 2 and 4.
 * This is where we set that up.
 */
@consumer
export class FGInitActionCube extends ExtendedSpinActionCube {
	@inject protected readonly nudgeUpService!: NudgeUpService;

	public override parse(response: ICubeResponse<INrgCubeGameResult>, adapter: BackendAdapterCube): IGameNetworkState {
		const result = super.parse(response, adapter);

		CacheStorage.set(CacheKeys.FirstFGSpinResponse, response);

		// check if we're in the case where fg is initialized with extra scatters, then we need to setup a nudge up before spinning
		// assumptions:
		// by default all freegames should start with reels 2 and 4 full of mystery symbols
		// => so we look at the reveals being given for reel 2
		// => if we get 4 reveals, we had 0 extra scatters
		// => if we get 3 reveals, we had 1 extra scatter
		// and so on

		const extraScatters =
			4 - result.slotGameBase.reels[1].slice(1, 5).filter((symbol) => symbol === BaseSymbolTypes.Mystery).length;

		const { intermediateReels, finalReels } = this.nudgeUpService.createNudgeInitialState(
			result.slotGameBase.reels,
			extraScatters
		);

		// we mock the initial fg state to have only basic nudging and reveal data for the first spin
		const mockInitialState: IGameNetworkState = {
			...result,
			slotGameBase: {
				...result.slotGameBase,
				reels: finalReels,
			},
			nudging: [0, 1, 0, 1, 0],
			reveal: {},
			preNudgeUpReels: intermediateReels,
		};

		return mockInitialState;
	}
}
